<!--
 * @Author: Haotian Zheng
 * @Date: 2023-07-13 19:28:04
 * @Descripttion:
 * @LastEditors: QiTianDaSheng
 * @LastEditTime: 2023-09-05 18:14:33
-->
<!-- 公共footer部分 -->
<template>
<div class="footerBox">
    <div class="footer">
        <div class="footer_left">
            <div class="footer_logo">
                <img src="../assets/image/footer/footer_logo.png" alt="" />
            </div>
            <p>服务热线：400-617-1118</p>
            <p>商务合作：swhz@ronghuinanhai.com</p>
        </div>
        <div class="footer_line"></div>
        <div class="footer_center">
            <p>版权所有：海南融汇南海科技有限公司</p>
            <a target="_black" href="https://beian.miit.gov.cn/#/Integrated/index">
                <p>备案号：琼ICP备2022002951号-5</p>
            </a>
            <a target="_black" href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=46010602001641">
                <p><i></i>琼公网安备46010602001641号</p>
            </a>
        </div>
        <div class="footer_line"></div>
        <div class="footer_right">
            <div class="imgBox">
                <img src="../assets/image/footer/footer_fuwu.jpg" alt="" />
                <p>关注服务号</p>
            </div>
            <div class="imgBox">
                <img src="../assets/image/footer/footer_dingyue.jpg" alt="" />
                <p>关注订阅号</p>
            </div>
        </div>
    </div>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {}
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {},
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.footerBox {
    width: 100%;
    height: 294px;
    background: #141b1e;

    .footer {
        display: flex;
        justify-content: space-between;

        width: 1200px;
        margin: 0 auto;
        height: 100%;
        padding-top: 78px;
        box-sizing: border-box;
        text-align: left;

        .footer_left {
            .footer_logo {
                width: 156px;
                height: 44px;
                margin-bottom: 4px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            p {
                margin-top: 24px;
                height: 20px;
                line-height: 20px;
                font-size: 14px;
                font-family: Alibaba PuHuiTi 2-65 Medium, Alibaba PuHuiTi 20;
                font-weight: 500;
                color: #fff;
            }
        }

        .footer_center {
            padding-top: 26px;

            p {
                display: flex;
                align-items: center;

                height: 20px;
                line-height: 20px;
                font-family: Alibaba PuHuiTi 2-65 Medium, Alibaba PuHuiTi 20;
                font-size: 14px;
                font-weight: 500;
                color: #fff;
                margin-bottom: 24px;

                i {
                    margin-right: 4px;
                    width: 26px;
                    height: 26px;
                    background-image: url("../assets/image/footer/footer_guohui.png");
                    background-size: 100% 100%;
                }
            }
        }

        .footer_line {
            margin-top: 9px;
            width: 1px;
            height: 139px;
            background-color: rgba(236, 236, 244, 0.2);
        }

        .footer_right {
            margin-top: 9px;
            display: flex;

            .imgBox {
                margin-right: 28px;
                width: 100px;
                height: 102px;
                background-image: url("../assets/image/footer/footer_qrCode_bg.png");
                background-size: 100% 100%;
                text-align: center;
                vertical-align: middle;

                img {
                    width: 90px;
                    height: 90px;
                    margin-top: 5px;
                }

                p {
                    line-height: 20px;
                    font-size: 14px;
                    font-weight: 500;
                    color: #fff;
                    font-family: Alibaba PuHuiTi 2-65 Medium, Alibaba PuHuiTi 20;
                    margin-top: 5px;
                }
            }
        }
    }
}
</style>
